// Shareable filter state via URL query string.
//
// Shape: ?q=<search>&reg=<reg-1..reg-4|all>&train=<0|1>
// Empty/default values are omitted from the URL.

import type { RegId } from './data/grimoire';

export type RegFilter = 'all' | RegId;

export interface FilterState {
  q: string;
  reg: RegFilter;
  train: boolean;
}

export function parseFilter(url = location.href): FilterState {
  const u = new URL(url);
  const reg = u.searchParams.get('reg');
  return {
    q: u.searchParams.get('q') ?? '',
    reg: reg && ['reg-1', 'reg-2', 'reg-3', 'reg-4'].includes(reg)
      ? (reg as RegId)
      : 'all',
    train: u.searchParams.get('train') === '1',
  };
}

export function buildFilterURL(state: FilterState, base = location): URL {
  const u = new URL(base.href);
  u.search = '';
  if (state.q) u.searchParams.set('q', state.q);
  if (state.reg !== 'all') u.searchParams.set('reg', state.reg);
  if (state.train) u.searchParams.set('train', '1');
  // Preserve hash (open entry).
  u.hash = base.hash;
  return u;
}
